<template>
	<router-link
		v-if="count > 0"
		:to="{ name: 'product-data.document-approvals' }"
		class="mb-5 flex items-center justify-between gap-3 rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 text-amber-900 transition hover:bg-amber-100">
		<div class="flex items-center gap-3">
			<app-icon :icon="['fas', 'clipboard-check']" class="text-amber-600" />
			<span class="text-sm font-medium">
				{{ count }} document{{ count === 1 ? '' : 's' }} await{{ count === 1 ? 's' : '' }}
				your approval.
			</span>
		</div>
		<span class="whitespace-nowrap text-sm font-semibold text-amber-700">
			Review now <app-icon :icon="['fas', 'arrow-right']" class="ml-1" />
		</span>
	</router-link>
</template>

<script lang="ts" setup>
	import { onMounted, ref } from 'vue'
	import DocumentService from '@/services/document'

	const count = ref(0)

	const load = async () => {
		try {
			const response = await new DocumentService().requiringApproval()
			const documents = response.data?.data ?? response.data ?? []
			count.value = Array.isArray(documents) ? documents.length : 0
		} catch (error) {
			// The dashboard remains usable if the approval count cannot be loaded.
			console.error('Error fetching documents requiring approval:', error)
		}
	}

	onMounted(load)
</script>
